import * as React from "react"
import Stack from "@mui/material/Stack"
import { Button } from "@mui/material"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import {
  setSelectedTransactionClass,
  setTableType,
} from "../../redux/slices/pnlReportingSlice"
import { tableTypes } from "./constants"
import { PnlReportingState } from "./types"

export default function NavigationBreadCrumbs() {
  const dispatch = useAppDispatch()
  const state: PnlReportingState = useAppSelector((state) => state.pnlReporting)
  const { selectedLineItem, pnlReportingSelectedClass, selectedTransaction } =
    state

  const breadcrumbs = React.useMemo(
    () => [
      {
        label: pnlReportingSelectedClass?.transaction_class,
        handler: () => {
          dispatch(setTableType(tableTypes.REPORTING))
          dispatch(setSelectedTransactionClass({}))
        },
      },
      {
        label: selectedLineItem,
        handler: () => {
          dispatch(setTableType(tableTypes.DETAIL))
          dispatch(setSelectedTransactionClass({}))
        },
      },
      {
        label: selectedTransaction?.transactionClass,
      },
      {
        label: selectedTransaction?.transactionSubClass,
      },
    ],
    [selectedLineItem, pnlReportingSelectedClass, selectedTransaction],
  )

  return (
    <Stack
      flexDirection={"row"}
      aria-label="navigation breadcrumbs back to reporting table"
      sx={{
        display: "flex",
        alignItems: "center",
        margin: "0px 20px 0px 20px",
        pl: "12px",
        height: "56px",
        color: "#fff",
        backgroundColor: "#3C77EF",
      }}
    >
      {breadcrumbs.map((crumb: any, index: number) => (
        <Button
          key={`crumb-${index}`}
          disableTouchRipple
          variant="text"
          color="inherit"
          sx={{
            fontWeight: "600",
            "&:Hover": {
              backgroundColor: "transparent",
              textDecoration: crumb?.handler ? "underline" : "none",
              cursor: crumb?.handler ? "pointer" : "default",
            },
          }}
          startIcon={<KeyboardArrowLeftIcon />}
          onClick={crumb?.handler}
        >
          {crumb.label}
        </Button>
      ))}
    </Stack>
  )
}
